import LocalStore from '@/utils/store';
import VoiceFn from '@/views/Voice/fn';
import store from '@/store/index';
import { CustomAudioVolumeInfo, CustomRtcConnection } from './typings';
import { message } from 'antd';
import { setKalaokInfo } from '@/views/Voice/store/module/kalaokInfo';
import { setOnlineInfo } from '@/views/Voice/store/module/onlineInfo';
import { stopLiveVideoSpecial } from '../../../voiceLiveVideo/rtc';
import useMutilPkStore from '@/hookStore/MutilPk';

export function getRoomInfo() {
  const roomInfo = VoiceFn.getLocalInfo('roomInfo');
  const token = roomInfo?.roomDetail?.agoraToken || '';
  const mainRoom = roomInfo?.roomId === roomInfo?.mainRoomId;
  const mainChannel = `${roomInfo?.roomId || 0}`;
  const childChannel = `pcVoice${roomInfo?.roomId || 0}`;
  const channel = mainRoom ? mainChannel : childChannel;
  const info: any = LocalStore.getValue('React-ant-Admin-user');
  const mainUid = `${info.userinfo.id || 0}`;
  const childUid = `pcVoice${info.userinfo.id || 0}`;
  const uid = mainRoom ? mainUid : childUid;
  return {
    token,
    channel,
    uid
  };
}

export function setVoiceRtcInitialized(initialized: boolean) {
  (window as any).voiceRtcInitialized = initialized;
}

export function isVoiceRtcInitialized(): boolean {
  return !!(window as any).voiceRtcInitialized;
}

export function ensureVoiceRtcEngine() {
  const boxAgora = (window as any).agora;
  if (!boxAgora?.createAgoraRtcEngine) {
    return null;
  }
  let rtcEngine = (window as any).rtcEngine;
  if (!rtcEngine) {
    rtcEngine = boxAgora.createAgoraRtcEngine();
    (window as any).rtcEngine = rtcEngine;
  }
  return rtcEngine;
}

/** 等待 ControlBar 完成 rtcEngine.initialize，避免 joinChannelEx 返回 -7 */
export function waitForVoiceRtcReady(timeoutMs = 15000): Promise<boolean> {
  return new Promise(resolve => {
    if (isVoiceRtcInitialized() && (window as any).rtcEngine) {
      resolve(true);
      return;
    }
    const start = Date.now();
    const timer = setInterval(() => {
      if (isVoiceRtcInitialized() && (window as any).rtcEngine) {
        clearInterval(timer);
        resolve(true);
        return;
      }
      if (Date.now() - start >= timeoutMs) {
        clearInterval(timer);
        resolve(false);
      }
    }, 200);
  });
}

/** PK 副频道 localUid：多频道场景需与主频道 uid 不同，优先 subRtcUid */
export function getPkLocalUid(fallbackUid?: number): number {
  const roomInfo = VoiceFn.getLocalInfo('roomInfo');
  const subRtcUid = roomInfo?.roomDetail?.subUser?.subRtcUid;
  if (subRtcUid) {
    return Number(subRtcUid);
  }
  return Number(fallbackUid || 0);
}
function getUserInfoByUid(uid: number) {
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    try {
      const info = rtcEngine.getUserInfoByUid(uid);
      return info && info.userAccount ? info.userAccount : uid;
    } catch (error) {
      console.log(error);
      return uid;
    }
  }
  return uid;
}

async function handleUserVolume(users: CustomAudioVolumeInfo[], totalVolume: number) {
  let oldVolumeInfo = '';
  let newVolumes: any = [];
  if (users.length) {
    if (!users[0].uid) {
      store.dispatch(
        setKalaokInfo({
          volume: totalVolume > 0 ? totalVolume + 20 : 0
        })
      );
      const timer = setTimeout(() => {
        clearTimeout(timer);
        store.dispatch(
          setKalaokInfo({
            volume: totalVolume > 0 ? totalVolume + 30 : 0
          })
        );
      }, 200);
    } else {
      newVolumes = users.map((item: any) => ({
        uid: getUserInfoByUid(item.uid),
        level: item.volume ? true : false
      }));
    }
  }
  if (!users.length || (users.length && users[0].uid)) {
    const newVolumesStr = JSON.parse(JSON.stringify(newVolumes));
    if (JSON.stringify(newVolumesStr) !== oldVolumeInfo) {
      oldVolumeInfo = JSON.stringify(newVolumesStr);
      const onlineInfo = VoiceFn.getLocalInfo('onlineInfo');
      store.dispatch(
        setOnlineInfo({
          ...onlineInfo,
          list: newVolumes
        })
      );
    }
  }
}

const EventHandles = {
  // 监听本地用户加入频道事件
  onJoinChannelSuccess: ({ channelId, localUid }: CustomRtcConnection, elapsed: number) => {
    // console.log(`监听本地用户加入频道事件 channel: ${channelId} uid: ${localUid} time: ${elapsed}`);
  },
  // 监听远端用户加入频道事件
  onUserJoined: ({ channelId, localUid }: CustomRtcConnection, remoteUid: number, elapsed: number) => {
    // console.log(
    //   `监听远端用户加入频道事件 channel: ${channelId} uid: ${localUid} remoteUid: ${remoteUid} time: ${elapsed}`
    // );
  },
  // 监听用户离开频道事件
  onUserOffline: ({ channelId, localUid }: CustomRtcConnection, remoteUid: number, reason: string) => {
    // console.log(
    //   `监听用户离开频道事件 channel: ${channelId} uid: ${localUid} remoteUid: ${remoteUid} reason: ${reason}`
    // );
    const currentChannel = getRoomInfo().channel;
    // PK 对方频道用户离线不影响本房间直播画面
    if (channelId !== currentChannel) return;

    const roomInfo = VoiceFn.getLocalInfo('roomInfo');
    const mainRoom = roomInfo?.roomId === roomInfo?.mainRoomId;
    const anchorId = LocalStore.getValue('VOICE_LIVEANCHOR_USERID', 0);
    let isAnchorOffline = anchorId === remoteUid;
    if (mainRoom && anchorId === Number(getUserInfoByUid(remoteUid))) {
      isAnchorOffline = true;
    }
    if (!mainRoom && `pcVoice${anchorId}` === getUserInfoByUid(remoteUid)) {
      isAnchorOffline = true;
    }
    if (isAnchorOffline) {
      const rtcEngine = (window as any).rtcEngine;
      rtcEngine.setupRemoteVideoEx(
        {
          uid: remoteUid,
          view: null,
          setupMode: 0
        },
        {
          channelId,
          localUid
        }
      );
    }
  },
  // 远端用户音频流状态
  onUserMuteAudio: ({ channelId, localUid }: CustomRtcConnection, remoteUid: number, muted: boolean) => {
    // console.log(`远端用户音频流状态 channel: ${channelId} uid: ${localUid} remoteUid: ${remoteUid} muted: ${muted}`);
  },
  // 远端用户视频流状态
  onUserMuteVideo: ({ channelId, localUid }: CustomRtcConnection, remoteUid: number, muted: boolean) => {
    if (!muted || channelId !== getRoomInfo().channel) return;

    const roomInfo = VoiceFn.getLocalInfo('roomInfo');
    const mainRoom = roomInfo?.roomId === roomInfo?.mainRoomId;
    const anchorId = LocalStore.getValue('VOICE_LIVEANCHOR_USERID', 0);
    let isAnchorMuted = anchorId === remoteUid;
    if (mainRoom && anchorId === Number(getUserInfoByUid(remoteUid))) {
      isAnchorMuted = true;
    }
    if (!mainRoom && `pcVoice${anchorId}` === getUserInfoByUid(remoteUid)) {
      isAnchorMuted = true;
    }
    if (isAnchorMuted) {
      clearMainAnchorVideo(localUid);
    }
  },
  // 用户音量提示回调
  onAudioVolumeIndication: (
    { channelId, localUid }: CustomRtcConnection,
    speakers: CustomAudioVolumeInfo[],
    speakerNumber: number,
    totalVolume: number
  ) => {
    handleUserVolume(speakers, totalVolume);
  },
  // 音频订阅状态
  onAudioSubscribeStateChanged: (
    channel: string,
    uid: number,
    oldState: number,
    newState: number,
    elapseSinceLastState: number
  ) => {
    // console.log(
    //   `音频订阅状态 channel: ${channel} uid: ${uid} oldState: ${oldState} newState: ${newState} elapseSinceLastState: ${elapseSinceLastState}`
    // );
  },
  // 视频订阅状态
  onVideoSubscribeStateChanged: (
    channel: string,
    uid: number,
    oldState: number,
    newState: number,
    elapseSinceLastState: number
  ) => {
    // console.log(
    //   `视频订阅状态 channel: ${channel} uid: ${uid} oldState: ${oldState} newState: ${newState} elapseSinceLastState: ${elapseSinceLastState}`
    // );
  },
  // 本地视频状态
  onVideoPublishStateChanged: (
    source: string,
    channel: string,
    oldState: number,
    newState: number,
    elapseSinceLastState: number
  ) => {
    // console.log(
    //   `本地视频状态 source: ${source} channel: ${channel} oldState: ${oldState} newState: ${newState} elapseSinceLastState: ${elapseSinceLastState}`
    // );
  },
  // 远端视频状态发生改变回调
  onRemoteVideoStateChanged: (
    { channelId, localUid }: CustomRtcConnection,
    remoteUid: number,
    state: number,
    reason: number,
    elapsed: boolean
  ) => {
    const anchorId = LocalStore.getValue('VOICE_LIVEANCHOR_USERID', 0);
    const isAnchor = anchorId === remoteUid;
    const isCurrentChannel = channelId === getRoomInfo().channel;
    if (reason === 5 && isAnchor && isCurrentChannel) {
      const rtcEngine = (window as any).rtcEngine;
      clearVideoBindCache(channelId, remoteUid);
      rtcEngine.setupRemoteVideoEx(
        {
          uid: remoteUid,
          view: null,
          setupMode: 0
        },
        {
          channelId,
          localUid
        }
      );
    }
    if (reason === 6) {
      // 多人 PK/连线期间由 MultiPkGlobal 槽位绑定视频，跳过 1v1 容器逻辑
      if (useMutilPkStore.getState().connectStatus > 0) {
        return;
      }
      bindChannelRemoteVideo(channelId, remoteUid, localUid);
    }
  },
  // 本地视频状态发生改变回调
  onLocalVideoStateChanged: (source: string, state: number, reason: number) => {
    if (state === 3) {
      switch (reason) {
        case 2:
          message.warning('没有权限启动本地视频采集设备');
          break;
        case 3:
          message.warning('视频采集设备正在使用中，请检查摄像头是否被其他 App 占用');
          break;
        case 4:
          message.warning('视频采集失败，请检查摄像头是否被其他 App 占用');
          break;
        default:
          message.warning(`本地视频状态改变原因，请联管理员 state: ${state} reason: ${reason}`);
          break;
      }
      stopLiveVideos();
      stopLiveVideo();
    }
  }
};

export function registerBoxRtc() {
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    rtcEngine.registerEventHandler(EventHandles);
  }
}

// 检验视频设备
export function validateEnumerateVideoDevices(deviceId: string) {
  const rtcEngine = (window as any).rtcEngine;
  const videoDeviceMgr = rtcEngine ? rtcEngine.getVideoDeviceManager() : undefined;
  if (videoDeviceMgr) {
    const videoDevices = videoDeviceMgr.enumerateVideoDevices();
    if (videoDevices && videoDevices.length) {
      const videoDeviceBol = videoDevices.some((item: any) => item.deviceId === deviceId);
      return videoDeviceBol;
    }
  }
  return false;
}

const clarityList = [
  {
    label: 'UHD',
    dimensions: {
      width: 1920,
      height: 1080
    },
    frameRate: 30
  },
  {
    label: 'HD',
    dimensions: {
      width: 1280,
      height: 720
    },
    frameRate: 15
  },
  {
    label: 'SD',
    dimensions: {
      width: 960,
      height: 540
    },
    frameRate: 15
  }
];

function getVideoConfig(clarity: string, portrait?: boolean) {
  const clarityInfo = clarityList.find((item: any) => item.label === clarity);
  if (portrait) {
    return {
      width: clarityInfo?.dimensions.height,
      height: clarityInfo?.dimensions.width
    };
  }
  return clarityInfo?.dimensions;
}

export function startLiveVideo(clarity: string, portrait?: boolean) {
  const deviceId = localStorage.getItem('VIOCE-LIVECAMERA-DEVICE');
  if (deviceId) {
    const videoDeviceBol = validateEnumerateVideoDevices(deviceId);
    if (videoDeviceBol) {
      const rtcEngine = (window as any).rtcEngine;
      if (rtcEngine) {
        rtcEngine.setClientRole(1);
        if (clarity) {
          rtcEngine.setVideoEncoderConfiguration({
            dimensions: getVideoConfig(clarity, portrait)
          });
        }
        // const cameraConfig = {
        //   deviceId,
        //   format: {
        //     width: 720,
        //     height: 1280,
        //     fps: 30
        //   },
        //   width: 720,
        //   height: 1280,
        //   // 采集分辨率高度
        //   frameRate: 30,
        //   // 帧率
        //   bitrate: 0,
        //   // 比特率，0表示自动调整
        //   orientationMode: 0,
        //   // 视频方向模式，默认0
        //   preference: 0
        //   // 输出偏好，默认0
        // };
        // 设置摄像头采集配置
        // rtcEngine.setCameraCapturerConfiguration(cameraConfig);
        // 设置采集视频的旋转角度
        // rtcEngine.setCameraDeviceOrientation(0, 90);
        const state = rtcEngine.startCameraCapture(0, {
          deviceId,
          format: getVideoConfig(clarity, portrait)
        });
        console.log(state);
        const state1 = rtcEngine.enableLocalVideo(true);
        console.log(state1);
        const state2 = rtcEngine.muteLocalVideoStream(false);
        console.log(state2);
        if (!state) setupLocalVideo(true);
      }
    } else {
      message.error('请重新选择摄像头');
    }
  } else {
    message.info('当前未在开播设置选择摄像头');
  }
}

export function stopLiveVideos() {
  try {
    const localVideoElement: any = document.getElementById('voiceLiveVideo');
    if (localVideoElement) {
      localVideoElement.innerHTML = '';
    }
  } catch (error) {
    console.log(error);
  }
}

export function stopLiveVideo() {
  stopLiveVideoSpecial();
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    try {
      rtcEngine.enableLocalVideo(false);
      rtcEngine.muteLocalVideoStream(true);
      setupLocalVideo(false);
    } catch (error) {
      console.log(error);
    }
  }
}

export function enableLocalAudio(mute: boolean) {
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    rtcEngine.enableLocalAudio(mute);
    rtcEngine.muteLocalAudioStream(!mute);
  }
}

/**
 * 开关本地视频采集
 * @param enabled boolean true:开启本地视频采集 false: 关闭本地视频采集
 */
export function enableLocalVideo(enabled: boolean) {
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    const state = rtcEngine.enableLocalVideo(enabled);
    if (!state) setupLocalVideo(enabled);
  }
}

/**
 * 设置视频预览的显示位置
 * @param enabled boolean true:开启本地视频采集 false: 关闭本地视频采集
 */
export function setupLocalVideo(enabled: boolean) {
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    const localVideoElement: any = document.getElementById('voiceLiveVideo');
    const state = rtcEngine.setupLocalVideo({
      sourceType: 0,
      view: enabled ? localVideoElement : null,
      setupMode: 0
    });
    if (!state && enabled) startPreview();
    if (!state && !enabled) stopPreview();
  }
}

const videoBindCache: Record<string, string> = {};

function getVideoBindKey(channelId: string, remoteUid: number): string {
  return `${channelId}_${remoteUid}`;
}

export function clearVideoBindCache(channelId?: string, remoteUid?: number) {
  if (channelId && remoteUid) {
    delete videoBindCache[getVideoBindKey(channelId, remoteUid)];
    return;
  }
  Object.keys(videoBindCache).forEach(key => {
    delete videoBindCache[key];
  });
}

/**
 * 按频道绑定远端视频：本房间 -> 左侧容器，对方 PK 频道 -> 右侧容器
 */
export function bindChannelRemoteVideo(channelId: string, remoteUid: number, localUid: number): boolean {
  const rtcEngine = (window as any).rtcEngine;
  if (!rtcEngine) {
    return false;
  }

  const currentChannel = getRoomInfo().channel;
  const isOpponentChannel = channelId !== currentChannel;

  createVideoContainers();

  const usePkLayout = getPkMode() || isOpponentChannel;
  updateVideoLayout(usePkLayout);

  const targetVideoElement = isOpponentChannel
    ? document.getElementById('voiceLiveVideo-remote')
    : document.getElementById('voiceLiveVideo-local') || document.getElementById('voiceLiveVideo');

  if (!targetVideoElement) {
    return false;
  }

  const viewId = targetVideoElement.id;
  const bindKey = getVideoBindKey(channelId, remoteUid);
  if (videoBindCache[bindKey] === viewId) {
    return true;
  }

  const result = rtcEngine.setupRemoteVideoEx(
    {
      uid: remoteUid,
      view: targetVideoElement,
      setupMode: 0
    },
    {
      channelId,
      localUid
    }
  );

  if (result === 0) {
    videoBindCache[bindKey] = viewId;
    return true;
  }
  return false;
}

/**
 * 创建双视频容器
 */
export function createVideoContainers() {
  const videoPlayer: any = document.getElementById('voiceLiveVideo');
  if (videoPlayer && !document.getElementById('voiceLiveVideo-local')) {
    // 创建本地视频容器
    const localContainer = document.createElement('div');
    localContainer.id = 'voiceLiveVideo-local';
    localContainer.className = 'voiceLiveVideo_local';
    localContainer.style.cssText = `
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    `;
    videoPlayer.appendChild(localContainer);

    // 创建远程视频容器
    const remoteContainer = document.createElement('div');
    remoteContainer.id = 'voiceLiveVideo-remote';
    remoteContainer.className = 'voiceLiveVideo_remote';
    remoteContainer.style.cssText = `
      width: 50%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
    `;
    videoPlayer.appendChild(remoteContainer);
  }
}

/**
 * 更新视频容器布局
 * @param isPkMode 是否为PK模式
 */
export function updateVideoLayout(isPkMode: boolean) {
  const localContainer = document.getElementById('voiceLiveVideo-local');
  const remoteContainer = document.getElementById('voiceLiveVideo-remote');

  if (localContainer) {
    if (isPkMode) {
      // PK模式：本地视频占左侧50%
      localContainer.style.cssText = `
        width: 50%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      `;
    } else {
      // 非PK模式：本地视频占100%
      localContainer.style.cssText = `
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      `;
    }
  }

  if (remoteContainer) {
    if (isPkMode) {
      // PK模式：远程视频占右侧50%
      remoteContainer.style.cssText = `
        width: 50%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
      `;
    } else {
      // 非PK模式：远程视频容器保持原样，由RTC引擎控制显示
      remoteContainer.style.cssText = `
        width: 50%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
      `;
    }
  }
}

/**
 * 设置PK模式状态
 * @param isPkMode 是否为PK模式
 */
export function setPkMode(isPkMode: boolean) {
  (window as any).isInPkMode = isPkMode;
  // 同时设置系统使用的PK状态变量
  (window as any).voicePkActive = isPkMode;
  // 更新视频布局
  updateVideoLayout(isPkMode);
}

/**
 * 获取PK模式状态
 */
export function getPkMode(): boolean {
  // 使用系统实际的PK状态变量
  return (window as any).voicePkActive || (window as any).isInPkMode || false;
}

/**
 * 清理本房间主播远端画面（主播下麦时观众端使用）
 */
export function clearMainAnchorVideo(localUid?: number) {
  const rtcEngine = (window as any).rtcEngine;
  const anchorId = LocalStore.getValue('VOICE_LIVEANCHOR_USERID', 0);

  if (rtcEngine && anchorId) {
    const roomInfo = getRoomInfo();
    const info: any = LocalStore.getValue('React-ant-Admin-user');
    const viewerUid = localUid ?? Number(info?.userinfo?.id || 0);

    try {
      rtcEngine.setupRemoteVideoEx(
        {
          uid: Number(anchorId),
          view: null,
          setupMode: 2
        },
        {
          channelId: roomInfo.channel,
          localUid: viewerUid
        }
      );
    } catch (error) {
      console.log(error);
    }
  }

  clearRemoteVideo();
  const localContainer = document.getElementById('voiceLiveVideo-local');
  if (localContainer) {
    localContainer.innerHTML = '';
  }
  stopLiveVideos();
}

/**
 * PK 结束后将本房间主播画面重新绑定到主容器（仅主播仍在麦上时）
 */
export function rebindMainAnchorVideo(localUid?: number, anchorId?: number) {
  const resolvedAnchorId = anchorId || LocalStore.getValue('VOICE_LIVEANCHOR_USERID', 0);
  if (!resolvedAnchorId) {
    clearMainAnchorVideo(localUid);
    return;
  }

  const rtcEngine = (window as any).rtcEngine;
  if (!rtcEngine) return;

  const roomInfo = getRoomInfo();
  const info: any = LocalStore.getValue('React-ant-Admin-user');
  const viewerUid = localUid ?? Number(info?.userinfo?.id || 0);
  if (!viewerUid) return;

  updateVideoLayout(false);

  const remoteContainer = document.getElementById('voiceLiveVideo-remote');
  if (remoteContainer) {
    remoteContainer.innerHTML = '';
  }

  const targetVideoElement =
    document.getElementById('voiceLiveVideo-local') || document.getElementById('voiceLiveVideo');
  if (!targetVideoElement) return;

  rtcEngine.setupRemoteVideoEx(
    {
      uid: Number(resolvedAnchorId),
      view: targetVideoElement,
      setupMode: 0
    },
    {
      channelId: roomInfo.channel,
      localUid: viewerUid
    }
  );
}

/**
 * 强制更新视频布局（根据当前PK状态）
 */
export function forceUpdateVideoLayout() {
  const isPkMode = getPkMode();
  console.log('🔄 强制更新视频布局，PK模式:', isPkMode);
  updateVideoLayout(isPkMode);
}

/**
 * 清理远程视频容器
 */
export function clearRemoteVideo() {
  const remoteVideoElement: any = document.getElementById('voiceLiveVideo-remote');
  if (remoteVideoElement) {
    remoteVideoElement.innerHTML = '';
  }
  const currentChannel = getRoomInfo().channel;
  Object.keys(videoBindCache).forEach(key => {
    if (!key.startsWith(`${currentChannel}_`)) {
      delete videoBindCache[key];
    }
  });
}

/**
 * 使用RTC引擎清理远程视频（使用正确的setupMode）
 * @param uid 要清理的用户ID
 * @param channelId 频道ID
 * @param localUid 本地用户ID
 */
export function clearRemoteVideoWithRTC(uid: number, channelId: string, localUid: number) {
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    rtcEngine.setupRemoteVideoEx(
      {
        uid: uid,
        view: null,
        setupMode: 2 // VideoViewSetupRemove: 删除视图
      },
      {
        channelId: channelId,
        localUid: localUid
      }
    );
  }
}

/**
 * 清理本地视频容器
 */
export function clearLocalVideo() {
  const localVideoElement: any = document.getElementById('voiceLiveVideo-local');
  if (localVideoElement) {
    // 清空视频内容
    localVideoElement.innerHTML = '';
  }
}

/**
 * 清理所有视频容器并移除DOM元素
 */
export function clearAllVideos() {
  clearLocalVideo();
  clearRemoteVideo();

  // 移除双视频容器，让videoPlayer重新变为空状态
  const videoPlayer: any = document.getElementById('voiceLiveVideo');
  if (videoPlayer) {
    const localContainer = document.getElementById('voiceLiveVideo-local');
    const remoteContainer = document.getElementById('voiceLiveVideo-remote');

    if (localContainer) {
      videoPlayer.removeChild(localContainer);
    }
    if (remoteContainer) {
      videoPlayer.removeChild(remoteContainer);
    }
  }
}

// 开启视频预览
export function startPreview() {
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    const state = rtcEngine.startPreview();
    if (!state) rtcEngine.muteLocalVideoStream(false);
  }
}

// 关闭视频预览
export function stopPreview() {
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    rtcEngine.stopPreview();
  }
}

// 重置rtc
export function resetRtc() {
  setVoiceRtcInitialized(false);
  const rtcEngine = (window as any).rtcEngine;
  if (!rtcEngine) {
    return;
  }
  try {
    stopLiveVideo();
    rtcEngine.leaveChannel();
    rtcEngine.unregisterEventHandler(EventHandles);
  } catch (error) {
    console.log(error);
  }
}

// 销毁rtc
export function destroyRtc() {
  setVoiceRtcInitialized(false);
  setPkMode(false);
  clearVideoBindCache();
  clearAllVideos();
  const rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    try {
      stopLiveVideo();
      rtcEngine.leaveChannel();
      rtcEngine.unregisterEventHandler(EventHandles);
      rtcEngine.release();
    } catch (error) {
      console.log(error);
    }
  }
  (window as any).rtcEngine = null;
}

// 默认打开的操作
export function muteLocalVideoStreamDefault(mute: boolean) {
  let rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) {
    const state = rtcEngine.muteLocalVideoStream(mute);
    if (!state) setupLocalVideo(!mute);
  }
}

export function muteLocalAudioStreamDefault(mute: boolean) {
  let rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) rtcEngine.muteLocalAudioStream(mute);
}

export function enableLoopbackRecordingDefault(mute: boolean) {
  let rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) rtcEngine.enableLoopbackRecording(mute);
}

export function adjustPlaybackSignalVolume(volume: number) {
  let rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) rtcEngine.adjustPlaybackSignalVolume(volume);
}

export function adjustRecordingSignalVolume(volume: number) {
  let rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) rtcEngine.adjustRecordingSignalVolume(volume);
}

export function adjustLoopbackSignalVolume(volume: number) {
  let rtcEngine = (window as any).rtcEngine;
  if (rtcEngine) rtcEngine.adjustLoopbackSignalVolume(volume);
}
